jQuery(document).ready(function($) {
    
    if($(window).width() >= 992 && $(window).height() >= 850) {
		$.scrollify({
	    	section : '.vc__section',
	  	});
    }

});
